export default __webpack_public_path__ + "static/media/v-shield-blue-bg.0ea2f5e3.png";